import type { Metadata } from 'next';

import { INVITE_EVENT_KEY } from '../constants';

export const INVITER_SECTION_IMAGES = {
  [INVITE_EVENT_KEY.NOVEMBER_EVENT_FIRST]: [
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/1.png',
      width: 1125,
      height: 2268,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/2.png',
      width: 1125,
      height: 1644,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/3.png',
      width: 1125,
      height: 1086,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/4.png',
      width: 1125,
      height: 1731,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/5.png',
      width: 1125,
      height: 432,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/6.png',
      width: 1125,
      height: 3554,
      className: 'bg-Gray-600',
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/7.png',
      width: 1125,
      height: 2253,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/8.png',
      width: 1125,
      height: 2820,
    },
  ],
  [INVITE_EVENT_KEY.NOVEMBER_EVENT_SECOND]: [
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/1-2.png',
      width: 1125,
      height: 2268,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/2.png',
      width: 1125,
      height: 1644,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/3.png',
      width: 1125,
      height: 1086,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/4.png',
      width: 1125,
      height: 1731,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/5.png',
      width: 1125,
      height: 432,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/6-2.png',
      width: 1125,
      height: 3554,
      className: 'bg-Gray-600',
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/7.png',
      width: 1125,
      height: 2253,
    },
    {
      src: 'https://cdn.welfarehello.com/donation/event/invite/nov/8.png',
      width: 1125,
      height: 2820,
    },
  ],
};

export const INVITE_CONFIG = {
  animation: {
    carouselRotationIntervalMs: 3000,
    transitionDurationSeconds: 0.6,
    easingCurve: [0.4, 0, 0.2, 1] as const,
  },
  share: {
    title: '웰로 초대장 혜택 : 134,000원',
    description: '친구 초대장으로 가입하면 즉시 134,000원이 지급됩니다.',
    thumbnailImageUrl:
      'https://cdn.welfarehello.com/donation/event/invite/donation-invite-og-new-3.jpg',
  },
} as const;

const INVITE_TEXT = {
  metadata: {
    pageTitle: '웰로 초대장 혜택 : 134,000원',
    pageDescription: '친구 초대장으로 가입해야 134,000원을 받을 수 있어요.',
    keywords: [
      '웰로 초대장',
      '웰로 친구 초대',
      '웰로 친구 초대 혜택',
      '웰로 친구 초대 혜택 134,000원',
      '웰로 친구 초대 무제한 혜택',
    ],
  },
} as const;

const INVITE_SITE = {
  baseUrl: 'https://www.welfarehello.com',
  siteName: '웰로',
} as const;

export const generateInviteMetadata = (): Metadata => {
  const title = INVITE_TEXT.metadata.pageTitle;
  const description = INVITE_TEXT.metadata.pageDescription;

  const INVITER_OG_IMAGE =
    'https://cdn.welfarehello.com/donation/event/invite/donation-invite-og-new-2.jpg';

  return {
    metadataBase: new URL(INVITE_SITE.baseUrl),
    title,
    description,
    robots: { index: false, follow: false },
    openGraph: {
      title,
      description,
      images: INVITER_OG_IMAGE,
      type: 'website',
      siteName: INVITE_SITE.siteName,
    },
    twitter: {
      card: 'summary_large_image',
      title,
      description,
      images: INVITER_OG_IMAGE,
    },
    keywords: [...INVITE_TEXT.metadata.keywords],
  } satisfies Metadata;
};
